import React from 'react'
import { useCookies } from 'react-cookie'
import { Navigate } from 'react-router-dom'

function getParameterValues(param, slicer, delimiter) {
  // writeDebugInfo('In getParameterValues func')
  const urlParms = window.location.href.slice(window.location.href.indexOf(slicer) + slicer.length).split(delimiter)
  for (let i = 0; i < urlParms.length; i += 1) {
    const urlparm = urlParms[i].split('=')
    if (urlparm[0].toLowerCase() === param) {
      return decodeURIComponent(urlparm[1])
    }
  }

  return ''
}

function Root() {
  const [, setCookie] = useCookies(['cookie-name'])
  const token = getParameterValues('id_token', '#', '&')
  setCookie('token', token)

  return <Navigate to="/bills" />
}

export default Root
